
// ExibirCompra.js

import React, { useState, useEffect } from 'react';
import ModalDetalhesFornecedor from './ModalDetalhesFornecedor'; // Certifique-se de que o caminho está correto
import ModalExibirItensCompra from './ModalExibirItensCompra'; // Importe o novo modal de consulta aqui
import ModalExibirParcelasCompra from './ModalExibirParcelasCompra'; // Importe o novo modal de consulta aqui
import RelatorioComprasModal from './RelatorioComprasModal'; // Supondo que o modal esteja em outro arquivo
import Box from '@mui/material/Box';
//import Axios from 'axios';
import api from '../config/axiosConfig';

import '../App.css';
import './ModalDetalhesCliente.css';
import './ModalContasAreceber.css';
 
function ExibirCompra({ compra = {}, handleCancelaExibe }) {
//
  const [detalhesFornecedor, setDetalhesFornecedor] = useState(false);
  const [exibirItensCompra, setExibirItensCompra] = useState(false);
  const [itensCompra, setItensCompra] = useState([]);
  const [exibirParcelasCompra, setExibirParcelasCompra] = useState(false);
  const [parcelasCompra, setParcelasCompra] = useState([]);

  const [codCompraParaExibir, setCodCompraParaExibir] = useState("");

  const [formData, setFormData] = useState({
    id: 0,       // Valor inicial para id da compra
    codcompra: '',
    dtcompra: '',
    tipo: '',

    idfornecedor: 0,  // Estado para armazenar dados do fornecedor selecionado
    nomefor: '',
    codfor: '',
    cnpjfor: '',
    empresa: '',
    codemp: '',
    cnpjemp: '',

    nfcompra: '',
    valcompra: 0, // Valor inicial para valcompra
    formapag: '',
    condpag: '',
    dtnfcompra: '',

    pesoliqd: 0,
    pesobruto: 0,
    unidade: '',
    entregues: 0,
    devolvidos: 0,
    saldo: 0,

    grupo: '',
    grupodesc: '',
    conta: '',
    contadesc: '',

    romaneio: '',
    placa: '',
    motorista: '',
    ajudante: '',
  });

  useEffect(() => {
    // Atualiza os detalhes da compra quando o componente é montado
    if (compra) {
      setFormData({
        ...compra,
        idfornecedor: compra?.fornecedor?.id || 0,
        nomefor: compra?.fornecedor.nomefor || '',
        codfor: compra?.fornecedor?.codfor || '',
        cnpjfor: compra?.fornecedor?.cnpjfor || '',
        valcompra: compra.valcompra || 0, // Atualizando valcompra no estado
        id: compra.id || 0,  // Certifique-se de armazenar o ID da compra no estado
      });
      setCodCompraParaExibir(compra.codcompra); // Definir o código da compra para atualizar
    }
  }, [compra]);

  const idCompra = compra ? compra.id : null; // Captura o 'id' da compra, ou define como 'null' se não houver Compra
  const idFornecedor = compra ? compra.fornecedor.id : null; // Captura o 'id' do Fornecedor, ou define como 'null' se não houver Fornecedor

  
  const fetchItensCompra = (codcompra) => {
    api.get(`/comprasitem/${codcompra}/itens`)
      .then(response => {
        console.log('Itens da compra recebidos:', response.data);
        setItensCompra(response.data);
      })
      .catch(error => {
        console.error('Erro ao buscar itens da compra:', error);
      });
  };


  const fetchParcelasCompra = (codcompra) => {
    api.get(`/apagar/${codcompra}/parcelas`)
      .then(response => {
        console.log('Parcelas da compra recebidos:', response.data);
        setParcelasCompra(response.data);
      })
      .catch(error => {
        console.error('Erro ao buscar Parcelas da compra:', error);
      });
  };


// Função para abrir ou fechar os detalhes do fornecedor
  const toggleDetalhesFornecedor = () => {
    setDetalhesFornecedor(!detalhesFornecedor);
  };

  
  // Função para abrir ou fechar o modal de Exibir Itens da Compra
  const toggleExibirItensCompra = (codcompra) => {
    console.log(`toggleExibirItensCompra chamado para compra ${codcompra}`);
    if (!exibirItensCompra && codcompra) {
      setCodCompraParaExibir(codcompra);
      fetchItensCompra(codcompra);
    }
    setExibirItensCompra(!exibirItensCompra);
  };
  
  // Função para abrir ou fechar o modal de Exibir Parcelas da Compra
  const toggleExibirParcelasCompra = (codcompra) => {
    console.log(`toggleExibirParcelasCompra chamado para compra ${codcompra}`);
    if (!exibirParcelasCompra && codcompra) {
      setCodCompraParaExibir(codcompra);
      fetchParcelasCompra(codcompra);
    }
    setExibirParcelasCompra(!exibirParcelasCompra);
  };

  // Função para formatar a data no formato "DD-MM-YYYY"
  const formatarData = (data) => {
    if (!data) return "Data não disponível";
    const partes = data.split('-');
    if (partes.length !== 3) return "Data inválida";
    const [ano, mes, dia] = partes;
    return `${dia}/${mes}/${ano}`;
  };


// Função para formatar o valor de crédito como moeda brasileira
  const formatarMoeda = (valor) => {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
  };

  const [openRelatorioModal, setOpenRelatorioModal] = useState(false);

  const handleOpenRelatorioModal = () => setOpenRelatorioModal(true);
  const handleCloseRelatorioModal = () => setOpenRelatorioModal(false);



  return (

    <div
      style={{
        minHeight: 'calc(100vh - 20px)',
        maxWidth: '900px',
        paddingTop: '10px',
        marginLeft: '0px',
        margin: '0 auto', // Centralizando o container
        textAlign: 'center', // Alinhamento central
      }}>

      <div style={{ marginBottom: '20px'}}>
        <h3>Controle de Compras</h3>
      </div>

      {/* Campos básicos da Compra */}
      {compra && (  
        
        <div style={{ textAlign: 'left', marginLeft: '20px' }}>

          <div style={{ display: 'flex', marginBottom: '0px' }}>

            <div style={{ width: '100px', marginRight: '20px' }}>
              <label style={{ display: 'block', width: '100px', marginRight: '20px' }}>Compra</label>
              <input type="text" value={compra.codcompra || ''} readOnly style={{ width: '100px', height: '30px' }} />
            </div>
            <div style={{ width: '120px' }}>
              <label style={{ display: 'block', width: '120px', marginBottom: '0px' }} translate="no">Data da Compra</label>
              <input type="text" value={formatarData(compra.dtcompra) || ''} readOnly style={{ width: '120px', height: '28px' }} />
            </div>
            <div style={{ width: '160px', marginLeft: '20px' }}>
            <label style={{ display: 'block', width: '160px'  }}>Tipo da Compra</label>
            <input type="text" value={compra.tipo || ''} readOnly style={{ width: '160px', height: '30px' }} />
            </div>
            
            <div style={{ marginLeft: '20px' }}>
              <button className="btn-truncate" title="Detalhes do Fornecedor"
                onClick={toggleDetalhesFornecedor} style={{ width: '110px', marginTop: '20px', height: '30px' }}>Fornecedor</button>
            </div>

            <div style={{ marginLeft: '20px' }}>
              <button onClick={() => toggleExibirItensCompra(compra.codcompra)} style={{ width: '120px', marginTop: '20px', height: '30px' }}>Exibir Itens</button>
            </div>

            <div style={{ marginLeft: '20px' }}>
              <button onClick={() => toggleExibirParcelasCompra(compra.codcompra)} style={{ width: '120px', marginTop: '20px', height: '30px' }}>Exibir Parcelas</button>
            </div>


          </div>

          <div style={{ display: 'flex', marginBottom: '0px' }}>
            <div style={{ marginRight: '20px', width: '420px' }}>
              <label style={{ display: 'block', width: '420px', marginRight: '20px' }}>Fornecedor</label>
              <input type="text" value={compra.nomefor || ''} readOnly style={{ width: '100%', height: '30px' }} />
               <br />
             </div>
            <div style={{ width: '100px' }}>
              <label style={{ display: 'block', width: '100px', marginBottom: '0px', whiteSpace: 'nowrap', 
              overflow: 'hidden', textOverflow: 'ellipsis' }} translate="no">Cód Fornecedor</label>
            <input type="text" value={compra.codfor || ''} readOnly style={{ width: '100px', height: '30px' }} />
            </div>
            
           <div style={{ width: '150px' }}>
              <label style={{ display: 'block', width: '150px', marginBottom: '0px', marginLeft: '20px' }}>CNPJ Fornecedor</label>
            <input type="text" value={compra.cnpjfor || ''} readOnly style={{ width: '150px', height: '30px', marginLeft: '20px' }} />
            </div>

            <div style={{ marginLeft: '40px', marginBottom: '0px', marginTop: '5px'  }}>
            <button onClick={handleOpenRelatorioModal}
            style={{ width: '100px', marginLeft: '0px', marginBottom: '0px', marginTop: '20px', height: '30px' }}>
            Relatórios</button>
            </div>

          </div>
          
          <div style={{ display: 'flex', marginBottom: '0px' }}>
          <div style={{ marginRight: '20px', width: '420px' }}>
            <label style={{ display: 'block', width: '420px' }}>Empresa</label>
            <input type="text" value={compra.empresa || ''} readOnly style={{ width: '420px', height: '30px' }} />
          </div>
          <div style={{ width: '100px', marginTop: '0px' }}>
              <label style={{ display: 'block', width: '100px', marginTop: '0px', whiteSpace: 'nowrap', 
              overflow: 'hidden', textOverflow: 'ellipsis' }} translate="no">Cód Empresa</label>
            <input type="text" value={compra.codemp || ''} readOnly style={{ width: '100px', height: '30px' }} />
          </div>            
          <div style={{ width: '150px', marginTop: '0px' }}>
            <label style={{ display: 'block', width: '150px', marginTop: '0px', marginLeft: '20px' }}>CNPJ Empresa</label>
            <input type="text" value={compra.cnpjemp || ''} readOnly style={{ width: '150px', marginLeft: '20px', marginTop: '0px', height: '30px' }} />
          </div>
            
          </div>
                   
        <div style={{ display: 'flex', marginTop: '0px' }}>
            
           <div style={{ width: '100px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '100px', marginBottom: '0px', marginRight: '20px' }}>Nota Fiscal</label>
            <input type="text" value={compra.nfcompra || ''} readOnly style={{ width: '100px', height: '28px' }} />
          </div>

        <div style={{ width: '100px', marginRight: '0px', marginBottom: '0px' }}>
          <label style={{ display: 'block', width: '100px' }}>Valor Compra</label>
          <input type="text" value={formatarMoeda(compra.valcompra) || ''} readOnly style={{ width: '100px', height: '30px' }} />
            </div>
            
        <div style={{ width: '180px', marginLeft: '20px', marginBottom: '0px' }}>
          <label style={{ display: 'block', width: '180px' }}>Forma de Pagamento</label>
          <input type="text" value={compra.formapag || ''} readOnly style={{ width: '180px', height: '30px' }} />
        </div>

        <div style={{ width: '240px', marginLeft: '20px', marginBottom: '0px' }}>
          <label style={{ display: 'block', width: '240px' }}>Condição de Pagamento</label>
          <input type="text" value={compra.condpag || ''} readOnly style={{ width: '240px', height: '30px' }} />
            </div>
            
      </div>
          
          <div style={{ display: 'flex', marginBottom: '0px' }}>
            
           <div style={{ width: '120px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '120px', marginBottom: '0px' }} translate="no">Data Nota Fiscal</label>
            <input type="text" value={formatarData(compra.dtnfcompra) || ''} readOnly style={{ width: '120px', height: '28px' }} />
           </div>

          <div style={{ width: '80px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '80px', marginRight: '20px' }} translate="no">Peso Liqd.</label>
            <input type="text" value={compra.pesoliqd || 0} readOnly style={{ width: '80px', height: '30px' }} />
          </div>
          <div style={{ width: '80px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '80px', marginRight: '20px'  }}>Peso Bruto</label>
            <input type="text" value={compra.pesobruto || 0} readOnly style={{ width: '80px', height: '30px' }} />
          </div>
          <div style={{ width: '80px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '80px', marginRight: '20px' }}>Unidade</label>
            <input type="text" value={compra.unidade || ''} readOnly style={{ width: '80px', height: '30px' }} />
          </div>
            
          <div style={{ width: '70px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '70px', marginRight: '20px' }}>Entregue</label>
            <input type="text" value={compra.entregues || 0} readOnly style={{ width: '70px', height: '30px' }} />
          </div>

          <div style={{ width: '70px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '70px', marginRight: '20px' }}>Devolvido</label>
            <input type="text" value={compra.devolvidos || 0} readOnly style={{ width: '70px', height: '30px' }} />
          </div>
 
          <div style={{ width: '60px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '60px', marginRight: '20px' }}>Saldo</label>
            <input type="text" value={compra.saldo || 0} readOnly style={{ width: '60px', height: '30px' }} />
          </div>
        </div>    

      <div style={{ display: 'flex', marginBottom: '0px' }}>
        <div style={{ width: '100px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '100px' }}>Grupo</label>
          <input type="text" value={compra.grupo || ''} readOnly style={{ width: '100px', height: '30px' }} />
        </div>
        <div style={{ width: '180px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '180px', marginRight: '20px' }}>Descrição</label>
          <input type="text" value={compra.grupodesc || ''} readOnly style={{ width: '180px', height: '30px' }} />
        </div>
        <div style={{ width: '100px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '100px', marginRight: '20px'  }}>conta</label>
          <input type="text" value={compra.conta || ''} readOnly style={{ width: '100px', height: '30px' }} />
        </div>
        <div style={{ width: '240px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '240px', marginRight: '20px' }}>Descrição</label>
          <input type="text" value={compra.contadesc || ''} readOnly style={{ width: '240px', height: '30px' }} />
        </div>   
      </div>          

      <div style={{ display: 'flex', marginBottom: '0px' }}>
        <div style={{ width: '110px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '110px' }}>Romaneio</label>
          <input type="text" value={compra.romaneio || ''} readOnly style={{ width: '110px', height: '30px' }} />
        </div>
        <div style={{ width: '110px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '110px', marginRight: '20px' }}>Veículo</label>
          <input type="text" value={compra.placa || ''} readOnly style={{ width: '110px', height: '30px' }} />
        </div>
        <div style={{ width: '160px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '160px', marginRight: '20px'  }}>Motorista</label>
          <input type="text" value={compra.motorista || ''} readOnly style={{ width: '160px', height: '30px' }} />
        </div>
        <div style={{ width: '160px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '160px', marginRight: '20px' }}>Ajudante</label>
          <input type="text" value={compra.ajudante || ''} readOnly style={{ width: '160px', height: '30px' }} />
        </div>   
          </div>    
          
      {detalhesFornecedor && compra?.fornecedor && (
        <ModalDetalhesFornecedor fornecedor={compra.fornecedor} fecharDetalhes={toggleDetalhesFornecedor} />
      )}
          
      {exibirItensCompra && (
        <ModalExibirItensCompra
          isOpen={exibirItensCompra}
          fecharModal={toggleExibirItensCompra}
          codCompra={codCompraParaExibir}
          itensCompra={itensCompra}
        />
          )}
          
          
      {exibirParcelasCompra && (
        <ModalExibirParcelasCompra
          isOpen={exibirParcelasCompra}
          fecharModal={toggleExibirParcelasCompra}
          codCompra={codCompraParaExibir}
          parcelasCompra={parcelasCompra}
        />
      )}


      <RelatorioComprasModal
          open={openRelatorioModal}
          handleClose={handleCloseRelatorioModal}
          idCompra={idCompra}  // Passa o ID da Venda para o Modal
          codCompra={formData.codcompra}  // Passa o Código do Cliente para o Modal
          idFornecedor={idFornecedor}  // Passa o ID do Cliente para o Modal
          codFor={formData.codfor}  // Passa o Código do Cliente para o Modal
        />

                
    </div>
  )}

  <br />
    
    <Box display="flex" justifyContent="center" alignItems="center" mt={0}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0px' }}>
        <button type="button" className='btn-menu' onClick={handleCancelaExibe}
          style={{ width: '150px', height: '30px', padding: '0px 0px', color: 'inherit' }}>Fechar Compras
        </button>
      </div>
    </Box>

  <br />
      
  </div>
    
  );
}  
  
export default ExibirCompra;